import PreviewDocumentModal from "./PreviewDocumentModalContainer";

export default PreviewDocumentModal;
